import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=028b0355&scoped=true&"
import script from "./theme.vue?vue&type=script&lang=ts&"
export * from "./theme.vue?vue&type=script&lang=ts&"
import style0 from "./theme.vue?vue&type=style&index=0&id=028b0355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b0355",
  null
  
)

export default component.exports